var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg23(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 516.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-8{fill:none;}.cls-1,.cls-2,.cls-3{stroke:#00a193;stroke-width:2px;}.cls-1,.cls-2,.cls-3,.cls-6,.cls-9{stroke-miterlimit:10;}.cls-2{fill:#f7f4ec;}.cls-3{fill:#fff;}.cls-10,.cls-4,.cls-6,.cls-7,.cls-9{fill:#364a49;}.cls-4,.cls-9{fill-rule:evenodd;}.cls-5{fill:#00b59e;}.cls-10,.cls-6,.cls-7,.cls-9{stroke:#364a49;}.cls-10,.cls-7,.cls-8{stroke-miterlimit:22.93;}.cls-7,.cls-8{stroke-width:0.63px;}.cls-8{stroke:#00b59e;}.cls-10{stroke-width:0.35px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 515.3,
    x2: 1920,
    y2: 515.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "761.18 77.11 798.3 77.11 807.09 515.3 752.39 515.3 761.18 77.11"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "798.3 77.11 779.74 50.6 761.18 77.11"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 793.44,
    y1: 140.35,
    x2: 797.11,
    y2: 504.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 792.97,
    y1: 94,
    x2: 793.23,
    y2: 119.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 388.56,
    y: 362.98,
    width: 188.34,
    height: 152.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 383.07,
    y: 356.7,
    width: 199.32,
    height: 6.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 374.81,
    y: 350.34,
    width: 215.85,
    height: 2.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 383.45,
    y: 338.91,
    width: 198.57,
    height: 11.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 461.83,
    y: 307.85,
    width: 41.8,
    height: 28.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 458.67,
    y1: 335.62,
    x2: 383.45,
    y2: 335.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 582.02,
    y1: 335.62,
    x2: 506.79,
    y2: 335.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M461.83,304.74h5.56a10.68,10.68,0,0,0,7.55-3.12l2.87-2.87a7.1,7.1,0,0,1,10.05,0l2.8,2.81a10.68,10.68,0,0,0,7.55,3.12h5.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M665.49,389h20.83a10.71,10.71,0,0,0,7.55-3.13l2.86-2.86a7.1,7.1,0,0,1,10,0l2.81,2.8a10.69,10.69,0,0,0,7.55,3.13h19.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 482.73,
    y1: 294.79,
    x2: 482.73,
    y2: 261.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 482.73,
    y: 261.81,
    width: 25.71,
    height: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 463.85,
    y1: 310.23,
    x2: 501.66,
    y2: 310.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M491.51,323.57a8.76,8.76,0,1,1-8.76-8.76A8.76,8.76,0,0,1,491.51,323.57Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "459.79 322.18 455.31 326.66 446.2 326.66"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 447.49,
    y1: 327.96,
    x2: 447.49,
    y2: 334.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "505.76 322.18 510.24 326.66 519.35 326.66"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 518.06,
    y1: 327.96,
    x2: 518.06,
    y2: 334.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 433.14,
    y: 368.25,
    width: 14.35,
    height: 147.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 518.06,
    y: 368.25,
    width: 14.35,
    height: 147.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 391.74,
    y: 457.36,
    width: 55.78,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 518.06,
    y: 457.36,
    width: 55.25,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 391.74,
    y: 400.36,
    width: 181.57,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M512.56,515.3H453V443a29.78,29.78,0,0,1,29.78-29.78h0A29.78,29.78,0,0,1,512.56,443Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M450.27,428.73a35.29,35.29,0,0,1,32.52-21.59h0A35.28,35.28,0,0,1,515,428.05"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 435.95,
    y: 418.13,
    width: 8.39,
    height: 35.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 521.04,
    y: 418.13,
    width: 8.39,
    height: 35.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M444.35,396.39H436V377.81a4.2,4.2,0,0,1,4.2-4.2h0a4.2,4.2,0,0,1,4.2,4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M529.43,396.39H521V377.81a4.2,4.2,0,0,1,4.19-4.2h0a4.2,4.2,0,0,1,4.2,4.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 435.95,
    y: 466.72,
    width: 8.39,
    height: 35.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 521.04,
    y: 466.72,
    width: 8.39,
    height: 35.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 398.34,
    y: 372.18,
    width: 4.82,
    height: 24.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 407.73,
    y: 372.18,
    width: 4.82,
    height: 24.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 417.13,
    y: 372.18,
    width: 4.82,
    height: 24.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 456.81,
    y: 372.18,
    width: 4.82,
    height: 24.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 466.21,
    y: 372.18,
    width: 4.82,
    height: 24.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 475.6,
    y: 372.18,
    width: 4.82,
    height: 24.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 485.12,
    y: 372.18,
    width: 4.82,
    height: 24.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 494.51,
    y: 372.18,
    width: 4.82,
    height: 24.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 503.91,
    y: 372.18,
    width: 4.82,
    height: 24.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 541.67,
    y: 372.18,
    width: 4.82,
    height: 24.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 551.07,
    y: 372.18,
    width: 4.82,
    height: 24.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 560.46,
    y: 372.18,
    width: 4.82,
    height: 24.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M407.65,416.1H415a3.17,3.17,0,0,1,3.17,3.17v33.89a0,0,0,0,1,0,0H404.48a0,0,0,0,1,0,0V419.27A3.17,3.17,0,0,1,407.65,416.1Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 407.07,
    y1: 422.53,
    x2: 415.52,
    y2: 422.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M604.31,456.29H590.65V426.05a6.83,6.83,0,0,1,6.83-6.83h0a6.83,6.83,0,0,1,6.83,6.83Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 593.25,
    y1: 425.65,
    x2: 601.7,
    y2: 425.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M686.22,456.29H672.57V426.05a6.82,6.82,0,0,1,6.82-6.83h0a6.83,6.83,0,0,1,6.83,6.83Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 675.16,
    y1: 425.65,
    x2: 683.61,
    y2: 425.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M707.1,456.29H693.44V426.05a6.83,6.83,0,0,1,6.83-6.83h0a6.83,6.83,0,0,1,6.83,6.83Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 696.03,
    y1: 425.65,
    x2: 704.49,
    y2: 425.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M728,456.29H714.32V426.05a6.83,6.83,0,0,1,6.83-6.83h0a6.82,6.82,0,0,1,6.82,6.83Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 716.91,
    y1: 425.65,
    x2: 725.36,
    y2: 425.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M628.08,456.29H614.42V426.05a6.83,6.83,0,0,1,6.83-6.83h0a6.83,6.83,0,0,1,6.83,6.83Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 617.01,
    y1: 425.65,
    x2: 625.47,
    y2: 425.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M651.85,456.29H638.19V426.05a6.83,6.83,0,0,1,6.83-6.83h0a6.83,6.83,0,0,1,6.83,6.83Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 640.78,
    y1: 425.65,
    x2: 649.23,
    y2: 425.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M604.31,508.85H590.65V478.61a6.83,6.83,0,0,1,6.83-6.83h0a6.83,6.83,0,0,1,6.83,6.83Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 593.25,
    y1: 478.22,
    x2: 601.7,
    y2: 478.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M686.22,508.85H672.57V478.61a6.82,6.82,0,0,1,6.82-6.83h0a6.83,6.83,0,0,1,6.83,6.83Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 675.16,
    y1: 478.22,
    x2: 683.61,
    y2: 478.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M707.1,508.85H693.44V478.61a6.83,6.83,0,0,1,6.83-6.83h0a6.83,6.83,0,0,1,6.83,6.83Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 696.03,
    y1: 478.22,
    x2: 704.49,
    y2: 478.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M728,508.85H714.32V478.61a6.83,6.83,0,0,1,6.83-6.83h0a6.82,6.82,0,0,1,6.82,6.83Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 716.91,
    y1: 478.22,
    x2: 725.36,
    y2: 478.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M628.08,508.85H614.42V478.61a6.83,6.83,0,0,1,6.83-6.83h0a6.83,6.83,0,0,1,6.83,6.83Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 617.01,
    y1: 478.22,
    x2: 625.47,
    y2: 478.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M651.85,508.85H638.19V478.61a6.83,6.83,0,0,1,6.83-6.83h0a6.83,6.83,0,0,1,6.83,6.83Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 640.78,
    y1: 478.22,
    x2: 649.23,
    y2: 478.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M561.69,453.16H548V422.93a6.83,6.83,0,0,1,6.83-6.83h0a6.82,6.82,0,0,1,6.82,6.83Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 550.64,
    y1: 422.53,
    x2: 559.09,
    y2: 422.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M407.65,467.79H415a3.17,3.17,0,0,1,3.17,3.17v33.89a0,0,0,0,1,0,0H404.48a0,0,0,0,1,0,0V471A3.17,3.17,0,0,1,407.65,467.79Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 407.07,
    y1: 474.23,
    x2: 415.52,
    y2: 474.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M561.69,504.86H548V474.62a6.83,6.83,0,0,1,6.83-6.83h0a6.82,6.82,0,0,1,6.82,6.83Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 550.64,
    y1: 474.23,
    x2: 559.09,
    y2: 474.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 393.81,
    y1: 338.91,
    x2: 393.81,
    y2: 344.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 396.56,
    y1: 338.91,
    x2: 396.56,
    y2: 344.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 399.31,
    y1: 338.91,
    x2: 399.31,
    y2: 344.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 402.06,
    y1: 338.91,
    x2: 402.06,
    y2: 344.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 404.81,
    y1: 338.91,
    x2: 404.81,
    y2: 344.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 407.56,
    y1: 338.91,
    x2: 407.56,
    y2: 344.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 410.31,
    y1: 338.91,
    x2: 410.31,
    y2: 344.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 413.06,
    y1: 338.91,
    x2: 413.06,
    y2: 344.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 415.81,
    y1: 338.91,
    x2: 415.81,
    y2: 344.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 418.56,
    y1: 338.91,
    x2: 418.56,
    y2: 344.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 421.31,
    y1: 338.91,
    x2: 421.31,
    y2: 344.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 424.06,
    y1: 338.91,
    x2: 424.06,
    y2: 344.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 426.81,
    y1: 338.91,
    x2: 426.81,
    y2: 344.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 429.56,
    y1: 338.91,
    x2: 429.56,
    y2: 344.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 535.6,
    y1: 338.91,
    x2: 535.6,
    y2: 344.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 538.35,
    y1: 338.91,
    x2: 538.35,
    y2: 344.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 541.1,
    y1: 338.91,
    x2: 541.1,
    y2: 344.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 543.85,
    y1: 338.91,
    x2: 543.85,
    y2: 344.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 546.6,
    y1: 338.91,
    x2: 546.6,
    y2: 344.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 549.35,
    y1: 338.91,
    x2: 549.35,
    y2: 344.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 552.1,
    y1: 338.91,
    x2: 552.1,
    y2: 344.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 554.85,
    y1: 338.91,
    x2: 554.85,
    y2: 344.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 557.6,
    y1: 338.91,
    x2: 557.6,
    y2: 344.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 560.35,
    y1: 338.91,
    x2: 560.35,
    y2: 344.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 563.1,
    y1: 338.91,
    x2: 563.1,
    y2: 344.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 565.85,
    y1: 338.91,
    x2: 565.85,
    y2: 344.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 568.6,
    y1: 338.91,
    x2: 568.6,
    y2: 344.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 571.35,
    y1: 338.91,
    x2: 571.35,
    y2: 344.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 576.9,
    y: 407.14,
    width: 165.8,
    height: 3.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 736.43,
    y1: 410.73,
    x2: 736.43,
    y2: 515.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 665.6,
    y1: 413.17,
    x2: 665.6,
    y2: 512.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 580.11,
    y: 461.36,
    width: 161.15,
    height: 3.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 665.6,
    y: 392.57,
    width: 70.83,
    height: 14.57
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "703.65 381.28 703.65 376.15 699.67 376.15 699.67 381.28"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "699.39 374.87 701.66 372.97 704.28 374.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M667,386.83a34.76,34.76,0,0,1,68.31,0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "707.39 358.91 707.39 355.16 696.01 355.16 696.01 358.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "696.01 353.56 701.66 350.66 707.39 353.56"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 576.9,
    y1: 372.97,
    x2: 672.57,
    y2: 372.97
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "590.65 351.63 667.01 351.63 675.16 370.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.6,389H278.77a10.69,10.69,0,0,1-7.55-3.13l-2.87-2.86a7.1,7.1,0,0,0-10.05,0l-2.8,2.8A10.71,10.71,0,0,1,248,389h-19.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M360.78,456.29h13.65V426.05a6.83,6.83,0,0,0-6.83-6.83h0a6.82,6.82,0,0,0-6.82,6.83Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 371.84,
    y1: 425.65,
    x2: 363.39,
    y2: 425.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M278.87,456.29h13.65V426.05a6.83,6.83,0,0,0-6.83-6.83h0a6.82,6.82,0,0,0-6.82,6.83Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 289.93,
    y1: 425.65,
    x2: 281.48,
    y2: 425.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258,456.29h13.66V426.05a6.83,6.83,0,0,0-6.83-6.83h0a6.83,6.83,0,0,0-6.83,6.83Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 269.05,
    y1: 425.65,
    x2: 260.6,
    y2: 425.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237.11,456.29h13.66V426.05a6.83,6.83,0,0,0-6.83-6.83h0a6.83,6.83,0,0,0-6.83,6.83Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 248.18,
    y1: 425.65,
    x2: 239.73,
    y2: 425.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337,456.29h13.65V426.05a6.82,6.82,0,0,0-6.82-6.83h0a6.83,6.83,0,0,0-6.83,6.83Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 348.07,
    y1: 425.65,
    x2: 339.62,
    y2: 425.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M313.24,456.29H326.9V426.05a6.83,6.83,0,0,0-6.83-6.83h0a6.83,6.83,0,0,0-6.83,6.83Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 324.31,
    y1: 425.65,
    x2: 315.85,
    y2: 425.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M360.78,508.85h13.65V478.61a6.83,6.83,0,0,0-6.83-6.83h0a6.82,6.82,0,0,0-6.82,6.83Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 371.84,
    y1: 478.22,
    x2: 363.39,
    y2: 478.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M278.87,508.85h13.65V478.61a6.83,6.83,0,0,0-6.83-6.83h0a6.82,6.82,0,0,0-6.82,6.83Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 289.93,
    y1: 478.22,
    x2: 281.48,
    y2: 478.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258,508.85h13.66V478.61a6.83,6.83,0,0,0-6.83-6.83h0a6.83,6.83,0,0,0-6.83,6.83Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 269.05,
    y1: 478.22,
    x2: 260.6,
    y2: 478.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237.11,508.85h13.66V478.61a6.83,6.83,0,0,0-6.83-6.83h0a6.83,6.83,0,0,0-6.83,6.83Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 248.18,
    y1: 478.22,
    x2: 239.73,
    y2: 478.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337,508.85h13.65V478.61a6.82,6.82,0,0,0-6.82-6.83h0a6.83,6.83,0,0,0-6.83,6.83Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 348.07,
    y1: 478.22,
    x2: 339.62,
    y2: 478.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M313.24,508.85H326.9V478.61a6.83,6.83,0,0,0-6.83-6.83h0a6.83,6.83,0,0,0-6.83,6.83Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 324.31,
    y1: 478.22,
    x2: 315.85,
    y2: 478.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 222.39,
    y: 407.14,
    width: 165.8,
    height: 3.59,
    transform: "translate(610.57 817.87) rotate(180)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 228.66,
    y1: 410.73,
    x2: 228.66,
    y2: 515.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 299.49,
    y1: 413.17,
    x2: 299.49,
    y2: 512.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 223.83,
    y: 461.36,
    width: 161.15,
    height: 3.96,
    transform: "translate(608.8 926.69) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 228.66,
    y: 392.57,
    width: 70.83,
    height: 14.57,
    transform: "translate(528.15 799.71) rotate(180)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "261.44 381.28 261.44 376.15 265.41 376.15 265.41 381.28"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "265.69 374.87 263.43 372.97 260.81 374.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.08,386.83a34.76,34.76,0,0,0-68.31,0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "257.7 358.91 257.7 355.16 269.07 355.16 269.07 358.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "269.07 353.56 263.43 350.66 257.7 353.56"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 388.19,
    y1: 372.97,
    x2: 292.52,
    y2: 372.97
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "374.43 351.63 298.08 351.63 289.93 370.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1436.82 298.42 1436.82 209.51 1485.6 209.51 1485.6 298.42"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1476.19,
    y1: 216.08,
    x2: 1480.63,
    y2: 216.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1441.95,
    y1: 216.08,
    x2: 1471.12,
    y2: 216.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1476.19,
    y1: 222.69,
    x2: 1480.63,
    y2: 222.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1441.95,
    y1: 222.69,
    x2: 1471.12,
    y2: 222.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1476.19,
    y1: 229.3,
    x2: 1480.63,
    y2: 229.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1441.95,
    y1: 229.3,
    x2: 1471.12,
    y2: 229.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1476.19,
    y1: 235.91,
    x2: 1480.63,
    y2: 235.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1441.95,
    y1: 235.91,
    x2: 1471.12,
    y2: 235.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1476.19,
    y1: 242.52,
    x2: 1480.63,
    y2: 242.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1441.95,
    y1: 242.52,
    x2: 1471.12,
    y2: 242.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1476.19,
    y1: 249.13,
    x2: 1480.63,
    y2: 249.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1441.95,
    y1: 249.13,
    x2: 1471.12,
    y2: 249.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1476.19,
    y1: 255.74,
    x2: 1480.63,
    y2: 255.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1441.95,
    y1: 255.74,
    x2: 1471.12,
    y2: 255.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1476.19,
    y1: 262.34,
    x2: 1480.63,
    y2: 262.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1441.95,
    y1: 262.34,
    x2: 1471.12,
    y2: 262.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1476.19,
    y1: 268.95,
    x2: 1480.63,
    y2: 268.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1441.95,
    y1: 268.95,
    x2: 1471.12,
    y2: 268.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1476.19,
    y1: 275.56,
    x2: 1480.63,
    y2: 275.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1441.95,
    y1: 275.56,
    x2: 1471.12,
    y2: 275.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1476.19,
    y1: 282.17,
    x2: 1480.63,
    y2: 282.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1441.95,
    y1: 282.17,
    x2: 1471.12,
    y2: 282.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1476.19,
    y1: 288.78,
    x2: 1480.63,
    y2: 288.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1441.95,
    y1: 288.78,
    x2: 1471.12,
    y2: 288.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1476.19,
    y1: 295.39,
    x2: 1480.63,
    y2: 295.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1441.95,
    y1: 295.39,
    x2: 1471.12,
    y2: 295.39
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1360.2 515.3 1425.2 515.3 1425.2 67.36 1360.2 97.16 1360.2 515.3"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1327.77,
    y: 236.58,
    width: 78.65,
    height: 278.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1336.64,
    y: 247.71,
    width: 8.61,
    height: 32.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1354.24,
    y: 247.71,
    width: 8.61,
    height: 32.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1371.84,
    y: 247.71,
    width: 8.61,
    height: 32.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1389.45,
    y: 247.71,
    width: 8.61,
    height: 32.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1336.64,
    y: 287.91,
    width: 8.61,
    height: 32.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1354.24,
    y: 287.91,
    width: 8.61,
    height: 32.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1371.84,
    y: 287.91,
    width: 8.61,
    height: 32.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1389.45,
    y: 287.91,
    width: 8.61,
    height: 32.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1336.64,
    y: 328.11,
    width: 8.61,
    height: 32.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1354.24,
    y: 328.11,
    width: 8.61,
    height: 32.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1371.84,
    y: 328.11,
    width: 8.61,
    height: 32.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1389.45,
    y: 328.11,
    width: 8.61,
    height: 32.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1336.64,
    y: 368.31,
    width: 8.61,
    height: 32.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1354.24,
    y: 368.31,
    width: 8.61,
    height: 32.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1371.84,
    y: 368.31,
    width: 8.61,
    height: 32.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1389.45,
    y: 368.31,
    width: 8.61,
    height: 32.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1336.64,
    y: 408.51,
    width: 8.61,
    height: 32.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1354.24,
    y: 408.51,
    width: 8.61,
    height: 32.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1371.84,
    y: 408.51,
    width: 8.61,
    height: 32.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1389.45,
    y: 408.51,
    width: 8.61,
    height: 32.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1336.64,
    y: 448.71,
    width: 8.61,
    height: 32.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1354.24,
    y: 448.71,
    width: 8.61,
    height: 32.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1371.84,
    y: 448.71,
    width: 8.61,
    height: 32.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1389.45,
    y: 448.71,
    width: 8.61,
    height: 32.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1360.2,
    y: 125.76,
    width: 46.22,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1360.2,
    y: 139.31,
    width: 46.22,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1360.2,
    y: 152.87,
    width: 46.22,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1360.2,
    y: 166.43,
    width: 46.22,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1360.2,
    y: 179.99,
    width: 46.22,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1360.2,
    y: 193.54,
    width: 46.22,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1360.2,
    y: 207.1,
    width: 46.22,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1360.2,
    y: 220.66,
    width: 46.22,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1248.78,
    y: 142.62,
    width: 97.67,
    height: 372.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1255.66,
    y: 152.17,
    width: 84.76,
    height: 6.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1255.66,
    y: 165.7,
    width: 84.76,
    height: 6.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1255.66,
    y: 179.24,
    width: 84.76,
    height: 6.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1255.66,
    y: 192.77,
    width: 84.76,
    height: 6.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1255.66,
    y: 206.31,
    width: 84.76,
    height: 6.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1255.66,
    y: 219.84,
    width: 84.76,
    height: 6.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1255.66,
    y: 233.37,
    width: 84.76,
    height: 6.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1255.66,
    y: 246.91,
    width: 84.76,
    height: 6.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1255.66,
    y: 260.44,
    width: 84.76,
    height: 6.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1255.66,
    y: 273.97,
    width: 84.76,
    height: 6.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1255.66,
    y: 287.51,
    width: 84.76,
    height: 6.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1255.66,
    y: 301.04,
    width: 84.76,
    height: 6.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1255.66,
    y: 314.58,
    width: 84.76,
    height: 6.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1255.66,
    y: 328.11,
    width: 84.76,
    height: 6.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1255.66,
    y: 341.64,
    width: 84.76,
    height: 6.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1255.66,
    y: 355.18,
    width: 84.76,
    height: 6.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1255.66,
    y: 368.71,
    width: 84.76,
    height: 6.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1255.66,
    y: 382.24,
    width: 84.76,
    height: 6.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1255.66,
    y: 395.78,
    width: 84.76,
    height: 6.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1255.66,
    y: 409.31,
    width: 84.76,
    height: 6.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1255.66,
    y: 422.85,
    width: 84.76,
    height: 6.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1255.66,
    y: 436.38,
    width: 84.76,
    height: 6.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1255.66,
    y: 449.91,
    width: 84.76,
    height: 6.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1255.66,
    y: 463.45,
    width: 84.76,
    height: 6.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1255.66,
    y: 476.98,
    width: 84.76,
    height: 6.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1255.66,
    y: 490.51,
    width: 84.76,
    height: 6.41
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1291.98 142.62 1295.75 72.39 1298.04 142.62 1291.98 142.62"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1358.81,
    y: 305.02,
    width: 156.02,
    height: 210.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1367.08,
    y: 314.58,
    width: 17.49,
    height: 27.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1391.48,
    y: 314.58,
    width: 17.49,
    height: 27.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1415.87,
    y: 314.58,
    width: 17.49,
    height: 27.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1440.27,
    y: 314.58,
    width: 17.49,
    height: 27.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1464.66,
    y: 314.58,
    width: 17.49,
    height: 27.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1489.06,
    y: 314.58,
    width: 17.49,
    height: 27.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1367.08,
    y1: 348.05,
    x2: 1506.55,
    y2: 348.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1367.08,
    y: 354.46,
    width: 17.49,
    height: 27.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1391.48,
    y: 354.46,
    width: 17.49,
    height: 27.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1415.87,
    y: 354.46,
    width: 17.49,
    height: 27.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1440.27,
    y: 354.46,
    width: 17.49,
    height: 27.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1464.66,
    y: 354.46,
    width: 17.49,
    height: 27.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1489.06,
    y: 354.46,
    width: 17.49,
    height: 27.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1367.08,
    y1: 387.94,
    x2: 1506.55,
    y2: 387.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1367.08,
    y: 394.35,
    width: 17.49,
    height: 27.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1391.48,
    y: 394.35,
    width: 17.49,
    height: 27.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1415.87,
    y: 394.35,
    width: 17.49,
    height: 27.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1440.27,
    y: 394.35,
    width: 17.49,
    height: 27.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1464.66,
    y: 394.35,
    width: 17.49,
    height: 27.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1489.06,
    y: 394.35,
    width: 17.49,
    height: 27.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1367.08,
    y1: 427.83,
    x2: 1506.55,
    y2: 427.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1367.08,
    y: 434.24,
    width: 17.49,
    height: 27.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1391.48,
    y: 434.24,
    width: 17.49,
    height: 27.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1415.87,
    y: 434.24,
    width: 17.49,
    height: 27.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1440.27,
    y: 434.24,
    width: 17.49,
    height: 27.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1464.66,
    y: 434.24,
    width: 17.49,
    height: 27.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1489.06,
    y: 434.24,
    width: 17.49,
    height: 27.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1367.08,
    y1: 467.72,
    x2: 1506.55,
    y2: 467.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1367.08,
    y: 474.13,
    width: 17.49,
    height: 27.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1391.48,
    y: 474.13,
    width: 17.49,
    height: 27.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1415.87,
    y: 474.13,
    width: 17.49,
    height: 27.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1440.27,
    y: 474.13,
    width: 17.49,
    height: 27.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1464.66,
    y: 474.13,
    width: 17.49,
    height: 27.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1489.06,
    y: 474.13,
    width: 17.49,
    height: 27.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1367.08,
    y1: 507.61,
    x2: 1506.55,
    y2: 507.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1712.57 515.3 1522.76 515.3 1522.76 88.59 1641.79 88.59 1697.67 195.98 1697.67 223.04 1712.57 280.38 1712.57 515.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1617.67 88.59 1569.81 1.74 1545.68 29.48 1545.68 88.59"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1531.25,
    y: 109.78,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1553.72,
    y: 109.78,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1576.18,
    y: 109.78,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1598.65,
    y: 109.78,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1621.12,
    y: 109.78,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1531.25,
    y: 132.36,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1553.72,
    y: 132.36,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1576.18,
    y: 132.36,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1598.65,
    y: 132.36,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1621.12,
    y: 132.36,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1642.4,
    y: 132.36,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1531.25,
    y: 154.95,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1553.72,
    y: 154.95,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1576.18,
    y: 154.95,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1598.65,
    y: 154.95,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1621.12,
    y: 154.95,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1642.4,
    y: 154.95,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1531.25,
    y: 177.53,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1553.72,
    y: 177.53,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1576.18,
    y: 177.53,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1598.65,
    y: 177.53,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1621.12,
    y: 177.53,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1642.4,
    y: 177.53,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1664.86,
    y: 177.53,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1531.25,
    y: 200.11,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1553.72,
    y: 200.11,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1576.18,
    y: 200.11,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1598.65,
    y: 200.11,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1621.12,
    y: 200.11,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1642.4,
    y: 200.11,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1664.86,
    y: 200.11,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1531.25,
    y: 222.69,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1553.72,
    y: 222.69,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1576.18,
    y: 222.69,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1598.65,
    y: 222.69,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1621.12,
    y: 222.69,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1642.4,
    y: 222.69,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1664.86,
    y: 222.69,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1531.25,
    y: 245.27,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1553.72,
    y: 245.27,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1576.18,
    y: 245.27,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1598.65,
    y: 245.27,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1621.12,
    y: 245.27,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1642.4,
    y: 245.27,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1664.86,
    y: 245.27,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1531.25,
    y: 267.85,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1553.72,
    y: 267.85,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1576.18,
    y: 267.85,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1598.65,
    y: 267.85,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1621.12,
    y: 267.85,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1642.4,
    y: 267.85,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1664.86,
    y: 267.85,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1687.33,
    y: 267.85,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1531.25,
    y: 290.43,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1553.72,
    y: 290.43,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1576.18,
    y: 290.43,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1598.65,
    y: 290.43,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1621.12,
    y: 290.43,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1642.4,
    y: 290.43,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1664.86,
    y: 290.43,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1687.33,
    y: 290.43,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1531.25,
    y: 313.01,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1553.72,
    y: 313.01,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1576.18,
    y: 313.01,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1598.65,
    y: 313.01,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1621.12,
    y: 313.01,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1642.4,
    y: 313.01,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1664.86,
    y: 313.01,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1687.33,
    y: 313.01,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1531.25,
    y: 335.59,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1553.72,
    y: 335.59,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1576.18,
    y: 335.59,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1598.65,
    y: 335.59,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1621.12,
    y: 335.59,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1642.4,
    y: 335.59,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1664.86,
    y: 335.59,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1687.33,
    y: 335.59,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1531.25,
    y: 358.17,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1553.72,
    y: 358.17,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1576.18,
    y: 358.17,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1598.65,
    y: 358.17,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1621.12,
    y: 358.17,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1642.4,
    y: 358.17,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1664.86,
    y: 358.17,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1687.33,
    y: 358.17,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1531.25,
    y: 380.75,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1553.72,
    y: 380.75,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1576.18,
    y: 380.75,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1598.65,
    y: 380.75,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1621.12,
    y: 380.75,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1642.4,
    y: 380.75,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1664.86,
    y: 380.75,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1687.33,
    y: 380.75,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1531.25,
    y: 403.33,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1553.72,
    y: 403.33,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1576.18,
    y: 403.33,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1598.65,
    y: 403.33,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1621.12,
    y: 403.33,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1642.4,
    y: 403.33,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1664.86,
    y: 403.33,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1687.33,
    y: 403.33,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1531.25,
    y: 425.91,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1553.72,
    y: 425.91,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1576.18,
    y: 425.91,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1598.65,
    y: 425.91,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1621.12,
    y: 425.91,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1642.4,
    y: 425.91,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1664.86,
    y: 425.91,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1687.33,
    y: 425.91,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1531.25,
    y: 448.5,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1553.72,
    y: 448.5,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1576.18,
    y: 448.5,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1598.65,
    y: 448.5,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1621.12,
    y: 448.5,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1642.4,
    y: 448.5,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1664.86,
    y: 448.5,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1687.33,
    y: 448.5,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1531.25,
    y: 471.08,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1553.72,
    y: 471.08,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1576.18,
    y: 471.08,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1598.65,
    y: 471.08,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1621.12,
    y: 471.08,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1642.4,
    y: 471.08,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1664.86,
    y: 471.08,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1687.33,
    y: 471.08,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1531.25,
    y: 493.66,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1553.72,
    y: 493.66,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1576.18,
    y: 493.66,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1598.65,
    y: 493.66,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1621.12,
    y: 493.66,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1642.4,
    y: 493.66,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1664.86,
    y: 493.66,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1687.33,
    y: 493.66,
    width: 15.97,
    height: 15.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 807.09,
    y1: 485.33,
    x2: 1248.78,
    y2: 485.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M807.09,477h294c11.11,0,15.69-14.25,6.66-20.73L975.84,361.6l161,86a240.45,240.45,0,0,0,89.44,27.17l22.48,2.24"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 982.62,
    y1: 366.46,
    x2: 831.3,
    y2: 476.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 988.58,
    y1: 370.74,
    x2: 843.15,
    y2: 476.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 994.54,
    y1: 375.02,
    x2: 855,
    y2: 476.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1000.5,
    y1: 379.29,
    x2: 866.86,
    y2: 476.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1006.46,
    y1: 383.57,
    x2: 878.71,
    y2: 476.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1012.42,
    y1: 387.84,
    x2: 890.57,
    y2: 476.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1018.38,
    y1: 392.12,
    x2: 902.42,
    y2: 476.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1024.35,
    y1: 396.4,
    x2: 914.27,
    y2: 476.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1030.31,
    y1: 400.67,
    x2: 926.13,
    y2: 476.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1036.27,
    y1: 404.95,
    x2: 937.98,
    y2: 476.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1042.23,
    y1: 409.22,
    x2: 949.84,
    y2: 476.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1048.19,
    y1: 413.5,
    x2: 961.69,
    y2: 476.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1054.15,
    y1: 417.77,
    x2: 973.55,
    y2: 476.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1060.11,
    y1: 422.05,
    x2: 985.4,
    y2: 476.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1066.07,
    y1: 426.33,
    x2: 997.25,
    y2: 476.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1072.03,
    y1: 430.6,
    x2: 1009.11,
    y2: 476.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1077.99,
    y1: 434.88,
    x2: 1020.96,
    y2: 476.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1083.95,
    y1: 439.15,
    x2: 1032.82,
    y2: 476.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1089.91,
    y1: 443.43,
    x2: 1044.67,
    y2: 476.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1095.87,
    y1: 447.71,
    x2: 1056.53,
    y2: 476.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1101.83,
    y1: 451.98,
    x2: 1068.38,
    y2: 476.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1107.79,
    y1: 456.26,
    x2: 1080.23,
    y2: 476.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M875,506.1h0a4.46,4.46,0,0,1-4.36-3.52l-3.75-17.25h16.22l-3.75,17.25A4.46,4.46,0,0,1,875,506.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1152.6,506.1h0a4.46,4.46,0,0,1-4.36-3.52l-3.75-17.25h16.22L1157,502.58A4.46,4.46,0,0,1,1152.6,506.1Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 807.09,
    y1: 507.12,
    x2: 1248.78,
    y2: 507.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M333.45,95.17V61.08H282.2V88.34h20.26V209.46h31v-33.6a79.41,79.41,0,0,1-4.23-9.3,82.34,82.34,0,0,1-4.06-14.92h0a95.91,95.91,0,0,1,0-32.13,82.38,82.38,0,0,1,4.08-15,79.07,79.07,0,0,1,4.2-9.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M468.61,78.35c2.84-2.57,6.07-3.68,9.41-3a13.3,13.3,0,0,1,4.34,1.59A34.62,34.62,0,0,0,479,70.56a10.13,10.13,0,0,0-6.88-4.28c-3.05-.61-6,.41-8.59,2.76a20.91,20.91,0,0,0-2.48,2.79c-2.28,3.06-4.49,6.27-6.61,9.6a214.43,214.43,0,0,0-16.13,30.95,298.34,298.34,0,0,0-19.28,66.31,237.25,237.25,0,0,0-3.33,33.15c0,1.83-.06,3.62-.05,5.38a80.93,80.93,0,0,0,.78,11.16c.3-5.47.81-11.16,1.53-17a313.37,313.37,0,0,1,6.68-36.21A319.89,319.89,0,0,1,441.79,124a229,229,0,0,1,18.68-34.84q2.64-4,5.43-7.71a22.17,22.17,0,0,1,2.71-3.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M453.57,80.41A69,69,0,0,0,430,63.13a76.11,76.11,0,0,0-58.14,0A69.29,69.29,0,0,0,348.14,80.4a78.77,78.77,0,0,0-14.69,22.93c-.32.78-.63,1.56-.93,2.36a84.08,84.08,0,0,0-5.21,29.93,83.3,83.3,0,0,0,5.18,29.71c.31.81.63,1.62,1,2.42A78.15,78.15,0,0,0,348,190.38a68.77,68.77,0,0,0,23.67,17.11,73.14,73.14,0,0,0,29.21,5.7,79.18,79.18,0,0,0,14.83-1.35,237.25,237.25,0,0,1,3.33-33.15l-1.15.55a40.34,40.34,0,0,1-17,3.43,36.06,36.06,0,0,1-16.05-3.56,40.92,40.92,0,0,1-13.4-10.89,52.74,52.74,0,0,1-9.18-15.92A53.92,53.92,0,0,1,359.22,134a54.55,54.55,0,0,1,2.86-18,46.35,46.35,0,0,1,8.54-14.9,35.88,35.88,0,0,1,13.07-9.89,42,42,0,0,1,17.11-3.31A42.58,42.58,0,0,1,418,91.16,36.4,36.4,0,0,1,431.12,101a45.73,45.73,0,0,1,7.23,11.39,214.43,214.43,0,0,1,16.13-30.95l-.91-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M459.17,142l-2.84,8.29h5.84Zm-3.65,10.91-1.74,4.39h-3.52l7.61-20.11h3l7.43,20.11h-3.55l-1.65-4.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "471.08 137.21 473.59 137.21 484.66 151.96 484.73 137.73 488.02 137.73 488.02 157.7 485.53 157.7 474.43 142.99 474.4 157.32 471.08 157.32 471.08 137.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M494.93,147.34a7.72,7.72,0,0,0,1.8,5,5.81,5.81,0,0,0,9,.1,7.89,7.89,0,0,0,1.71-5.14,7.31,7.31,0,0,0-1.71-4.9,6.21,6.21,0,0,0-9.1,0,7.31,7.31,0,0,0-1.71,4.87m-3.46.23a10.5,10.5,0,0,1,2.78-7.32,9.43,9.43,0,0,1,13.87,0,11.06,11.06,0,0,1,0,14.55,9.56,9.56,0,0,1-13.94,0A10.33,10.33,0,0,1,491.47,147.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M523.84,141.7a3.74,3.74,0,0,0-3.19-1.78,3,3,0,0,0-2.07.75,2.52,2.52,0,0,0-.84,2c0,.84,1,1.84,3.07,3s3,1.71,3.07,1.71a4.67,4.67,0,0,1,2.16,3.81,6.88,6.88,0,0,1-1.71,4.84,6.13,6.13,0,0,1-4.75,1.87c-2.55,0-4.55-1.26-6-3.81l2.1-2.06a5.13,5.13,0,0,0,1.55,2.06,3.58,3.58,0,0,0,2.32.94,2.82,2.82,0,0,0,2.26-1,3.46,3.46,0,0,0,.81-2.35,2.72,2.72,0,0,0-.62-1.78,15.28,15.28,0,0,0-4.13-2.32c-2.35-1-3.55-2.52-3.55-4.45a5.82,5.82,0,0,1,1.65-4.2,5.33,5.33,0,0,1,4.07-1.68,6.89,6.89,0,0,1,5.35,2.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "463.3 171.51 463.3 163.54 466.59 163.54 466.59 183.13 463.3 183.13 463.3 174.13 455.2 174.13 455.2 183.13 451.87 183.13 451.87 163.54 455.2 163.54 455.2 171.51 463.3 171.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M473.53,173.16a7.67,7.67,0,0,0,1.81,5,5.78,5.78,0,0,0,9,.1,7.88,7.88,0,0,0,1.71-5.13,7.29,7.29,0,0,0-1.71-4.9,6.21,6.21,0,0,0-9.1,0,7.29,7.29,0,0,0-1.71,4.87m-3.45.23a10.52,10.52,0,0,1,2.77-7.33,9.46,9.46,0,0,1,13.88,0,11.09,11.09,0,0,1,0,14.56,9.56,9.56,0,0,1-13.94,0A10.32,10.32,0,0,1,470.08,173.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M502.45,167.51a3.77,3.77,0,0,0-3.2-1.77,3,3,0,0,0-2.06.74,2.52,2.52,0,0,0-.84,2c0,.84,1,1.84,3.06,3s3,1.71,3.07,1.71a4.64,4.64,0,0,1,2.16,3.81,6.88,6.88,0,0,1-1.71,4.84,6.11,6.11,0,0,1-4.74,1.87c-2.55,0-4.55-1.26-6-3.81l2.1-2.06a5.13,5.13,0,0,0,1.55,2.06,3.65,3.65,0,0,0,2.32.94,2.85,2.85,0,0,0,2.26-1,3.49,3.49,0,0,0,.81-2.36,2.68,2.68,0,0,0-.61-1.77,15.38,15.38,0,0,0-4.13-2.33c-2.36-1-3.55-2.51-3.55-4.45a5.8,5.8,0,0,1,1.64-4.19,5.34,5.34,0,0,1,4.07-1.68,6.87,6.87,0,0,1,5.35,2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M511.55,173.16h1.64c2.43,0,3.65-1.19,3.65-3.55s-1.26-3.42-3.74-3.42h-1.55Zm0,10h-3.33V163.54h5.2c4.55,0,6.81,2,6.81,6.07s-2.1,6.2-6.26,6.2h-2.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "526.88 166.35 526.88 171.45 533.46 171.45 533.46 174.26 526.88 174.26 526.88 180.32 533.69 180.32 533.69 183.13 523.56 183.13 523.56 163.54 533.69 163.54 533.69 166.35 526.88 166.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M541.18,180.13h1.13c4.68,0,7-2.26,7-6.81s-2.35-6.77-7-6.77h-1.13Zm-3.33-16.59h5.49a9.06,9.06,0,0,1,6.84,2.78,9.83,9.83,0,0,1,2.62,7,9.69,9.69,0,0,1-2.65,7,9,9,0,0,1-6.84,2.81h-5.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M563.54,167.84l-2.84,8.29h5.85Zm-3.64,10.9-1.74,4.39h-3.52l7.61-20.1h3l7.42,20.1h-3.55l-1.64-4.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "575.46 163.03 577.97 163.03 589.04 177.78 589.11 163.54 592.4 163.54 592.4 183.52 589.91 183.52 578.81 168.81 578.78 183.13 575.46 183.13 575.46 163.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M600.11,180.13h1.13c4.68,0,7-2.26,7-6.81s-2.36-6.77-7-6.77h-1.13Zm-3.32-16.59h5.48a9.06,9.06,0,0,1,6.84,2.78,9.79,9.79,0,0,1,2.62,7,9.65,9.65,0,0,1-2.65,7,9,9,0,0,1-6.84,2.81h-5.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M617.7,173.16a7.73,7.73,0,0,0,1.81,5,5.78,5.78,0,0,0,9,.1,7.88,7.88,0,0,0,1.71-5.13,7.29,7.29,0,0,0-1.71-4.9,6.21,6.21,0,0,0-9.1,0,7.29,7.29,0,0,0-1.71,4.87m-3.45.23a10.52,10.52,0,0,1,2.77-7.33,9.46,9.46,0,0,1,13.88,0,11.09,11.09,0,0,1,0,14.56,9.56,9.56,0,0,1-13.94,0A10.32,10.32,0,0,1,614.25,173.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "455.2 192.17 455.2 197.27 461.78 197.27 461.78 200.07 455.2 200.07 455.2 206.14 462 206.14 462 208.95 451.87 208.95 451.87 189.36 462 189.36 462 192.17 455.2 192.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "466.17 188.84 468.69 188.84 479.76 203.59 479.82 189.36 483.11 189.36 483.11 209.34 480.63 209.34 469.53 194.62 469.5 208.95 466.17 208.95 466.17 188.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M500,197.78h1.48c1.84,0,2.78-.93,2.78-2.84s-.91-3-2.74-3H500Zm0,8.52h1.84c2.55,0,3.81-1.06,3.81-3.23,0-1.93-1.33-2.9-4-2.9H500Zm-3.32-16.94h4.77c3.91,0,5.87,1.78,5.87,5.32a4.34,4.34,0,0,1-1.71,3.81,3.48,3.48,0,0,1,2.46,1.65,6,6,0,0,1,.87,3.26,5,5,0,0,1-1.71,4.13,7.07,7.07,0,0,1-4.55,1.42h-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M512.54,189.36h3.33v11c0,4.23,1.32,6.33,4,6.33s4-2.1,4-6.33v-11h3.29v11.71q0,8.38-7.26,8.39t-7.3-8.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "534.72 192.17 534.72 197.27 541.3 197.27 541.3 200.07 534.72 200.07 534.72 206.14 541.53 206.14 541.53 208.95 531.39 208.95 531.39 189.36 541.53 189.36 541.53 192.17 534.72 192.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "545.69 188.84 548.21 188.84 559.28 203.59 559.34 189.36 562.63 189.36 562.63 209.34 560.15 209.34 549.05 194.62 549.01 208.95 545.69 208.95 545.69 188.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M569.54,199a7.73,7.73,0,0,0,1.81,5,5.8,5.8,0,0,0,9,.1,7.88,7.88,0,0,0,1.71-5.13,7.32,7.32,0,0,0-1.71-4.91,6.21,6.21,0,0,0-9.1,0,7.32,7.32,0,0,0-1.71,4.88m-3.45.22a10.49,10.49,0,0,1,2.77-7.32,9.44,9.44,0,0,1,13.88,0,11.07,11.07,0,0,1,0,14.55,9.56,9.56,0,0,1-13.94,0A10.32,10.32,0,0,1,566.09,199.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M598.46,193.33a3.78,3.78,0,0,0-3.2-1.78,3,3,0,0,0-2.06.75,2.52,2.52,0,0,0-.84,2c0,.83,1,1.83,3.07,3s3,1.71,3.06,1.71a4.67,4.67,0,0,1,2.16,3.81,6.86,6.86,0,0,1-1.71,4.84,6.11,6.11,0,0,1-4.74,1.87c-2.55,0-4.55-1.25-6-3.8l2.09-2.07a5.23,5.23,0,0,0,1.55,2.07,3.66,3.66,0,0,0,2.33.93,2.84,2.84,0,0,0,2.26-1,3.51,3.51,0,0,0,.8-2.35,2.71,2.71,0,0,0-.61-1.78,15.77,15.77,0,0,0-4.13-2.32c-2.36-1-3.55-2.52-3.55-4.45a5.85,5.85,0,0,1,1.64-4.2,5.36,5.36,0,0,1,4.07-1.68A6.91,6.91,0,0,1,600,191Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M620.69,193.65l-2.84,8.3h5.84Zm-3.64,10.91L615.3,209h-3.51l7.61-20.11h3L629.79,209h-3.55l-1.64-4.39Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 632.86,
    y: 189.36,
    width: 3.32,
    height: 19.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M644.13,198.88h1c2.74,0,4.09-1.16,4.09-3.52s-1.35-3.39-4.06-3.39h-1ZM653.81,209h-4.1l-5.55-8.71,0,8.71H640.8V189.36H646c4.35,0,6.55,2,6.55,5.91a6.06,6.06,0,0,1-1.13,3.71,4.44,4.44,0,0,1-3.13,1.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "660.23 192.17 660.23 197.27 666.82 197.27 666.82 200.07 660.23 200.07 660.23 206.14 667.04 206.14 667.04 208.95 656.91 208.95 656.91 189.36 667.04 189.36 667.04 192.17 660.23 192.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M680.69,193.33a3.75,3.75,0,0,0-3.19-1.78,3,3,0,0,0-2.07.75,2.56,2.56,0,0,0-.84,2c0,.83,1,1.83,3.07,3s3,1.71,3.07,1.71a4.67,4.67,0,0,1,2.16,3.81,6.86,6.86,0,0,1-1.71,4.84,6.13,6.13,0,0,1-4.75,1.87c-2.54,0-4.55-1.25-6-3.8l2.1-2.07a5.23,5.23,0,0,0,1.55,2.07,3.64,3.64,0,0,0,2.32.93,2.82,2.82,0,0,0,2.26-1,3.46,3.46,0,0,0,.81-2.35,2.72,2.72,0,0,0-.62-1.78,15.58,15.58,0,0,0-4.13-2.32c-2.35-1-3.55-2.52-3.55-4.45a5.82,5.82,0,0,1,1.65-4.2,5.34,5.34,0,0,1,4.07-1.68,6.89,6.89,0,0,1,5.35,2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M459.17,142l-2.84,8.29h5.84Zm-3.65,10.91-1.74,4.39h-3.52l7.61-20.11h3l7.43,20.11h-3.55l-1.65-4.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "471.08 137.21 473.59 137.21 484.66 151.96 484.73 137.73 488.02 137.73 488.02 157.7 485.53 157.7 474.43 142.99 474.4 157.32 471.08 157.32 471.08 137.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M494.93,147.34a7.72,7.72,0,0,0,1.8,5,5.81,5.81,0,0,0,9,.1,7.89,7.89,0,0,0,1.71-5.14,7.31,7.31,0,0,0-1.71-4.9,6.21,6.21,0,0,0-9.1,0A7.31,7.31,0,0,0,494.93,147.34Zm-3.46.23a10.5,10.5,0,0,1,2.78-7.32,9.43,9.43,0,0,1,13.87,0,11.06,11.06,0,0,1,0,14.55,9.56,9.56,0,0,1-13.94,0A10.33,10.33,0,0,1,491.47,147.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M523.84,141.7a3.74,3.74,0,0,0-3.19-1.78,3,3,0,0,0-2.07.75,2.52,2.52,0,0,0-.84,2c0,.84,1,1.84,3.07,3s3,1.71,3.07,1.71a4.67,4.67,0,0,1,2.16,3.81,6.88,6.88,0,0,1-1.71,4.84,6.13,6.13,0,0,1-4.75,1.87c-2.55,0-4.55-1.26-6-3.81l2.1-2.06a5.13,5.13,0,0,0,1.55,2.06,3.58,3.58,0,0,0,2.32.94,2.82,2.82,0,0,0,2.26-1,3.46,3.46,0,0,0,.81-2.35,2.72,2.72,0,0,0-.62-1.78,15.28,15.28,0,0,0-4.13-2.32c-2.35-1-3.55-2.52-3.55-4.45a5.82,5.82,0,0,1,1.65-4.2,5.33,5.33,0,0,1,4.07-1.68,6.89,6.89,0,0,1,5.35,2.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "463.3 171.51 463.3 163.54 466.59 163.54 466.59 183.13 463.3 183.13 463.3 174.13 455.2 174.13 455.2 183.13 451.87 183.13 451.87 163.54 455.2 163.54 455.2 171.51 463.3 171.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M473.53,173.16a7.67,7.67,0,0,0,1.81,5,5.78,5.78,0,0,0,9,.1,7.88,7.88,0,0,0,1.71-5.13,7.29,7.29,0,0,0-1.71-4.9,6.21,6.21,0,0,0-9.1,0A7.29,7.29,0,0,0,473.53,173.16Zm-3.45.23a10.52,10.52,0,0,1,2.77-7.33,9.46,9.46,0,0,1,13.88,0,11.09,11.09,0,0,1,0,14.56,9.56,9.56,0,0,1-13.94,0A10.32,10.32,0,0,1,470.08,173.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M502.45,167.51a3.77,3.77,0,0,0-3.2-1.77,3,3,0,0,0-2.06.74,2.52,2.52,0,0,0-.84,2c0,.84,1,1.84,3.06,3s3,1.71,3.07,1.71a4.64,4.64,0,0,1,2.16,3.81,6.88,6.88,0,0,1-1.71,4.84,6.11,6.11,0,0,1-4.74,1.87c-2.55,0-4.55-1.26-6-3.81l2.1-2.06a5.13,5.13,0,0,0,1.55,2.06,3.65,3.65,0,0,0,2.32.94,2.85,2.85,0,0,0,2.26-1,3.49,3.49,0,0,0,.81-2.36,2.68,2.68,0,0,0-.61-1.77,15.38,15.38,0,0,0-4.13-2.33c-2.36-1-3.55-2.51-3.55-4.45a5.8,5.8,0,0,1,1.64-4.19,5.34,5.34,0,0,1,4.07-1.68,6.87,6.87,0,0,1,5.35,2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M511.55,173.16h1.64c2.43,0,3.65-1.19,3.65-3.55s-1.26-3.42-3.74-3.42h-1.55Zm0,10h-3.33V163.54h5.2c4.55,0,6.81,2,6.81,6.07s-2.1,6.2-6.26,6.2h-2.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "526.88 166.35 526.88 171.45 533.46 171.45 533.46 174.26 526.88 174.26 526.88 180.32 533.69 180.32 533.69 183.13 523.56 183.13 523.56 163.54 533.69 163.54 533.69 166.35 526.88 166.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M541.18,180.13h1.13c4.68,0,7-2.26,7-6.81s-2.35-6.77-7-6.77h-1.13Zm-3.33-16.59h5.49a9.06,9.06,0,0,1,6.84,2.78,9.83,9.83,0,0,1,2.62,7,9.69,9.69,0,0,1-2.65,7,9,9,0,0,1-6.84,2.81h-5.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M563.54,167.84l-2.84,8.29h5.85Zm-3.64,10.9-1.74,4.39h-3.52l7.61-20.1h3l7.42,20.1h-3.55l-1.64-4.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "575.46 163.03 577.97 163.03 589.04 177.78 589.11 163.54 592.4 163.54 592.4 183.52 589.91 183.52 578.81 168.81 578.78 183.13 575.46 183.13 575.46 163.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M600.11,180.13h1.13c4.68,0,7-2.26,7-6.81s-2.36-6.77-7-6.77h-1.13Zm-3.32-16.59h5.48a9.06,9.06,0,0,1,6.84,2.78,9.79,9.79,0,0,1,2.62,7,9.65,9.65,0,0,1-2.65,7,9,9,0,0,1-6.84,2.81h-5.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M617.7,173.16a7.73,7.73,0,0,0,1.81,5,5.78,5.78,0,0,0,9,.1,7.88,7.88,0,0,0,1.71-5.13,7.29,7.29,0,0,0-1.71-4.9,6.21,6.21,0,0,0-9.1,0A7.29,7.29,0,0,0,617.7,173.16Zm-3.45.23a10.52,10.52,0,0,1,2.77-7.33,9.46,9.46,0,0,1,13.88,0,11.09,11.09,0,0,1,0,14.56,9.56,9.56,0,0,1-13.94,0A10.32,10.32,0,0,1,614.25,173.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "455.2 192.17 455.2 197.27 461.78 197.27 461.78 200.07 455.2 200.07 455.2 206.14 462 206.14 462 208.95 451.87 208.95 451.87 189.36 462 189.36 462 192.17 455.2 192.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "466.17 188.84 468.69 188.84 479.76 203.59 479.82 189.36 483.11 189.36 483.11 209.34 480.63 209.34 469.53 194.62 469.5 208.95 466.17 208.95 466.17 188.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M500,197.78h1.48c1.84,0,2.78-.93,2.78-2.84s-.91-3-2.74-3H500Zm0,8.52h1.84c2.55,0,3.81-1.06,3.81-3.23,0-1.93-1.33-2.9-4-2.9H500Zm-3.32-16.94h4.77c3.91,0,5.87,1.78,5.87,5.32a4.34,4.34,0,0,1-1.71,3.81,3.48,3.48,0,0,1,2.46,1.65,6,6,0,0,1,.87,3.26,5,5,0,0,1-1.71,4.13,7.07,7.07,0,0,1-4.55,1.42h-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M512.54,189.36h3.33v11c0,4.23,1.32,6.33,4,6.33s4-2.1,4-6.33v-11h3.29v11.71q0,8.38-7.26,8.39t-7.3-8.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "534.72 192.17 534.72 197.27 541.3 197.27 541.3 200.07 534.72 200.07 534.72 206.14 541.53 206.14 541.53 208.95 531.39 208.95 531.39 189.36 541.53 189.36 541.53 192.17 534.72 192.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "545.69 188.84 548.21 188.84 559.28 203.59 559.34 189.36 562.63 189.36 562.63 209.34 560.15 209.34 549.05 194.62 549.01 208.95 545.69 208.95 545.69 188.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M569.54,199a7.73,7.73,0,0,0,1.81,5,5.8,5.8,0,0,0,9,.1,7.88,7.88,0,0,0,1.71-5.13,7.32,7.32,0,0,0-1.71-4.91,6.21,6.21,0,0,0-9.1,0A7.32,7.32,0,0,0,569.54,199Zm-3.45.22a10.49,10.49,0,0,1,2.77-7.32,9.44,9.44,0,0,1,13.88,0,11.07,11.07,0,0,1,0,14.55,9.56,9.56,0,0,1-13.94,0A10.32,10.32,0,0,1,566.09,199.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M598.46,193.33a3.78,3.78,0,0,0-3.2-1.78,3,3,0,0,0-2.06.75,2.52,2.52,0,0,0-.84,2c0,.83,1,1.83,3.07,3s3,1.71,3.06,1.71a4.67,4.67,0,0,1,2.16,3.81,6.86,6.86,0,0,1-1.71,4.84,6.11,6.11,0,0,1-4.74,1.87c-2.55,0-4.55-1.25-6-3.8l2.09-2.07a5.23,5.23,0,0,0,1.55,2.07,3.66,3.66,0,0,0,2.33.93,2.84,2.84,0,0,0,2.26-1,3.51,3.51,0,0,0,.8-2.35,2.71,2.71,0,0,0-.61-1.78,15.77,15.77,0,0,0-4.13-2.32c-2.36-1-3.55-2.52-3.55-4.45a5.85,5.85,0,0,1,1.64-4.2,5.36,5.36,0,0,1,4.07-1.68A6.91,6.91,0,0,1,600,191Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M620.69,193.65l-2.84,8.3h5.84Zm-3.64,10.91L615.3,209h-3.51l7.61-20.11h3L629.79,209h-3.55l-1.64-4.39Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 632.86,
    y: 189.36,
    width: 3.32,
    height: 19.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M644.13,198.88h1c2.74,0,4.09-1.16,4.09-3.52s-1.35-3.39-4.06-3.39h-1ZM653.81,209h-4.1l-5.55-8.71,0,8.71H640.8V189.36H646c4.35,0,6.55,2,6.55,5.91a6.06,6.06,0,0,1-1.13,3.71,4.44,4.44,0,0,1-3.13,1.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "660.23 192.17 660.23 197.27 666.82 197.27 666.82 200.07 660.23 200.07 660.23 206.14 667.04 206.14 667.04 208.95 656.91 208.95 656.91 189.36 667.04 189.36 667.04 192.17 660.23 192.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M680.69,193.33a3.75,3.75,0,0,0-3.19-1.78,3,3,0,0,0-2.07.75,2.56,2.56,0,0,0-.84,2c0,.83,1,1.83,3.07,3s3,1.71,3.07,1.71a4.67,4.67,0,0,1,2.16,3.81,6.86,6.86,0,0,1-1.71,4.84,6.13,6.13,0,0,1-4.75,1.87c-2.54,0-4.55-1.25-6-3.8l2.1-2.07a5.23,5.23,0,0,0,1.55,2.07,3.64,3.64,0,0,0,2.32.93,2.82,2.82,0,0,0,2.26-1,3.46,3.46,0,0,0,.81-2.35,2.72,2.72,0,0,0-.62-1.78,15.58,15.58,0,0,0-4.13-2.32c-2.35-1-3.55-2.52-3.55-4.45a5.82,5.82,0,0,1,1.65-4.2,5.34,5.34,0,0,1,4.07-1.68,6.89,6.89,0,0,1,5.35,2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M474.28,133.56h2.09a1.57,1.57,0,0,1,.33-1.12,1.11,1.11,0,0,1,.87-.38,3.8,3.8,0,0,1,1.54.57,5.88,5.88,0,0,0,2.62.88,2.88,2.88,0,0,0,2.18-.9,3.93,3.93,0,0,0,.91-2.69h-2.05a2,2,0,0,1-.38,1.09,1,1,0,0,1-.77.28,3.61,3.61,0,0,1-1.48-.47,6.48,6.48,0,0,0-2.67-.86,3,3,0,0,0-2.3,1A3.57,3.57,0,0,0,474.28,133.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M474.28,133.56h2.09a1.57,1.57,0,0,1,.33-1.12,1.11,1.11,0,0,1,.87-.38,3.8,3.8,0,0,1,1.54.57,5.88,5.88,0,0,0,2.62.88,2.88,2.88,0,0,0,2.18-.9,3.93,3.93,0,0,0,.91-2.69h-2.05a2,2,0,0,1-.38,1.09,1,1,0,0,1-.77.28,3.61,3.61,0,0,1-1.48-.47,6.48,6.48,0,0,0-2.67-.86,3,3,0,0,0-2.3,1A3.57,3.57,0,0,0,474.28,133.56Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg23);
export default __webpack_public_path__ + "static/media/23.e3cf74e3fbd2a01e6f6230dd56cda5ec.svg";
export { ForwardRef as ReactComponent };